import { useState } from "react";
import { Forward } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MailOutDialog } from "@/components/mail-out-dialog";
import { useAuth } from "@/contexts/auth-context";

interface PulseForwardButtonProps {
  pulseId: number;
  projectId: string;
  className?: string;
}

/**
 * Shared forwarding entry point for both incoming and sent email pulses.
 * The composer resolves the immutable source snapshot from the pulse itself.
 */
export function PulseForwardButton({ pulseId, projectId, className }: PulseForwardButtonProps) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  if (user?.role !== 'admin' && user?.role !== 'team') return null;

  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={() => setOpen(true)}
        className={className || "bg-slate-700 hover:bg-slate-600 text-white"}
        aria-label="Forward email"
        data-testid={`button-forward-email-pulse-${pulseId}`}
      >
        <Forward className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" />
        Forward
      </Button>
      <MailOutDialog
        open={open}
        onOpenChange={setOpen}
        projectId={projectId}
        composeLabel="Forward"
        forwardSource={{ pulseId }}
      />
    </>
  );
}